/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/scripts/sections/cart-aside/main.js":
/*!*******************************************************!*\
  !*** ./resources/scripts/sections/cart-aside/main.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cartAside": () => (/* binding */ cartAside),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var cartAside = function cartAside() {
  var cart = window.Carbon.Cart;
  var $cartAsideBackground = document.querySelector(".cart-aside__background");
  var $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
  if ($cartAside) {
    // Function for setting gift note
    var setNote = function setNote(note) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          note: note
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        //console.log('Cart updated with note:', data);
      })["catch"](function (error) {
        return console.error("Error updating cart:", error);
      });
    }; // Gift note toggling & input
    cart.setUpCartAside($cartAside);
    var $body = document.querySelector("body");
    var closeCartAside = function closeCartAside(event) {
      event.preventDefault();
      $body.classList.remove("overflow-y-hidden");
      $cartAsideBackground.classList.add("pointer-events-none");
      $cartAsideBackground.classList.remove("bg-black", "bg-opacity-40");
      $cartAside.classList.add("translate-x-full", "ponter-events-none");
    };
    $cartAsideBackground.addEventListener("click", function (event) {
      if (event.target == $cartAsideBackground) {
        closeCartAside(event);
      }
    });
    var $cartAsideClose = $cartAside.querySelector(".cart-aside__close");
    $cartAsideClose.addEventListener("click", function (event) {
      event.stopPropagation();
      closeCartAside(event);
    });
    document.addEventListener("change", function (e) {
      if (e.target.matches(".cart-aside__is-gift")) {
        var $giftContainer = e.target.closest(".cart-aside__gift");
        var $giftText = $giftContainer.querySelector("#order-note-text");
        if (e.target.checked) {
          $giftContainer.classList.add("active");
          setNote($giftText.value);
        } else {
          $giftContainer.classList.remove("active");
          setNote("");
        }
      }
    });
    document.addEventListener("input", function (e) {
      if (e.target.matches("#order-note-text")) {
        setNote(e.target.value);
      }
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (cartAside);
document.addEventListener("DOMContentLoaded", cartAside);

/***/ }),

/***/ "./resources/styles/app.scss":
/*!***********************************!*\
  !*** ./resources/styles/app.scss ***!
  \***********************************/
/***/ (() => {

throw new Error("Module build failed (from ./node_modules/mini-css-extract-plugin/dist/loader.js):\nModuleBuildError: Module build failed (from ./node_modules/postcss-loader/dist/cjs.js):\nSyntaxError\n\n(1240:1) /Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/resources/styles/app.scss `@responsive` is used but `@tailwind utilities` is missing.\n\n \u001b[90m 1238 | \u001b[39m\u001b[33m}\u001b[39m\n \u001b[90m 1239 | \u001b[39m\n\u001b[1m\u001b[31m>\u001b[39m\u001b[22m\u001b[90m 1240 | \u001b[39m\u001b[36m@responsive\u001b[39m \u001b[33m{\u001b[39m\n \u001b[90m      | \u001b[39m\u001b[1m\u001b[31m^\u001b[39m\u001b[22m\n \u001b[90m 1241 | \u001b[39m  \u001b[33m.h-app\u001b[39m \u001b[33m{\u001b[39m\n \u001b[90m 1242 | \u001b[39m    height\u001b[33m:\u001b[39m \u001b[36mvar\u001b[39m\u001b[36m(--app-height)\u001b[39m\u001b[33m;\u001b[39m\n\n    at processResult (/Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/webpack/lib/NormalModule.js:758:19)\n    at /Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/webpack/lib/NormalModule.js:860:5\n    at /Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/loader-runner/lib/LoaderRunner.js:400:11\n    at /Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/loader-runner/lib/LoaderRunner.js:252:18\n    at context.callback (/Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/loader-runner/lib/LoaderRunner.js:124:13)\n    at Object.loader (/Users/Shared/Files From i.localized/Files/shopify2/Mother root/Mother-Root/node_modules/postcss-loader/dist/index.js:140:7)");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	__webpack_modules__["./resources/scripts/sections/cart-aside/main.js"](0, {}, __webpack_require__);
/******/ 	// This entry module doesn't tell about it's top-level declarations so it can't be inlined
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./resources/styles/app.scss"](0, __webpack_exports__, __webpack_require__);
/******/ 	
/******/ })()
;